import { useCallback } from "react";
import styles from "./Accounts.module.scss"
import { StatusFailure } from "../../home/children/SocketStatusController/SocketStatusController";

export const FailTokenLogin: React.FC = () => {
    const doRetry = useCallback(() => {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
    }, [])

    return (
        <div className={styles.accounts}>
            <StatusFailure context="token_login" retryAction={doRetry} />
        </div>
    )
}

export default FailTokenLogin;
